export default __webpack_public_path__ + "static/volume-b2eea1f2fdd854d2e6470ff519c79b37.png";